import { Cog6ToothIcon } from "@heroicons/react/24/outline";

const TAB_CONFIG = [
    { id: "product", label: "Product BOM" },
    { id: "bundle", label: "Bundle BOM" },
    { id: "packaging", label: "Packaging" },
    { id: "supplies", label: "Supplies" },
];

const BomHeader = ({ activeTab, counts, onChangeTab, onOpenSettings, onOpenChangeHistory }) => {
    return (
        <div className="border-b border-gray-200 bg-white">
            <div className="flex items-start justify-between gap-4 px-5 py-3">
                <div>
                    <div className="mb-1 flex items-center gap-1.5 text-xs text-gray-400">
                        <span>Inventory</span>
                        <span>/</span>
                        <span className="font-medium text-gray-600">Bill of Materials</span>
                    </div>
                    <h1 className="text-lg font-semibold text-gray-900">Bill of Materials</h1>
                </div>
                <div className="flex items-center gap-3">
                    <p className="hidden text-right text-xs text-gray-400 lg:block">
                        Component breakdown, costs, and supplier data for all catalog SKUs.
                    </p>
                    <button
                        type="button"
                        onClick={onOpenChangeHistory}
                        className="inline-flex h-8 items-center rounded-md border border-gray-200 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
                    >
                        Change History
                    </button>
                    <button
                        type="button"
                        onClick={onOpenSettings}
                        className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-500 transition-colors hover:bg-gray-50 hover:text-gray-900"
                        title="BOM settings"
                    >
                        <Cog6ToothIcon className="h-4 w-4" />
                    </button>
                </div>
            </div>
            <div className="flex items-center gap-0 overflow-x-auto px-5">
                {TAB_CONFIG.map((tab) => {
                    const isActive = activeTab === tab.id;
                    return (
                        <button
                            key={tab.id}
                            type="button"
                            onClick={() => onChangeTab(tab.id)}
                            className={[
                                "inline-flex items-center gap-2 whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors",
                                isActive
                                    ? "border-gray-900 text-gray-900"
                                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
                            ].join(" ")}
                        >
                            <span>{tab.label}</span>
                            <span
                                className={[
                                    "rounded-full px-2 py-0.5 text-xs tabular-nums",
                                    isActive ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-500",
                                ].join(" ")}
                            >
                                {counts[tab.id] || 0}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default BomHeader;
